<template>
    <div class="container py-5 text-center">
        <h1 class="orange m-0">Strona nie istnieje</h1>
    </div>
</template>

<script>
export default {
    name: "NotFoundPage"
}
</script>

<style scoped>

</style>
